<template>
  <div class="wrap-content bg-light pt-3 pt-lg-5 pb-5">
    <b-container fluid>
      <b-row>
        <b-col cols="12" lg="3" xl="2" class="p-0 aside-menu-dashboard-wrap">
          <DashUserNav></DashUserNav>
        </b-col>
        <b-col cols="12" lg="9" xl="10" class="pl-3 pl-lg-3 mt-3 welcome-dashboard">

          <h1 class="display-4">{{`Olá ${user.firstName}`}}<span v-if="user.additionalInformation.type === 'pj'">{{user.additionalInformation.businessName ? ' (' : ''}}{{user.additionalInformation.businessName}}{{user.additionalInformation.businessName ? ')' : ''}}</span>.</h1>
          <p>Seja bem vindo(a) ao painel da Pedale.
          <small class="text-muted d-block font-weight-light">Hoje é dia {{ date }}.</small>
          </p>

           <b-row>
              <b-col cols="12">
                 <div class="mb-4">
                    <el-divider
                       content-position="left">Avisos</el-divider>
                    <small
                       v-if="userIsReady && userDidNotCheckThePhone"
                       v-loading="loading.user"
                       style="background-color: #ececec" class="p-4 rounded-lg d-block mb-2"> Tudo certo por aqui ;) </small>


                    <el-alert
                       v-if="!userIsReady"
                       title="Complete seu perfil!"
                       type="blue"
                       effect="dark"
                       :closable="false"
                       class="mb-3"
                    >
                       <template slot>Estamos muitos felizes por você compartilhar experiências conosco. Para você usar todos
                          os recursos da plataforma Pedale, por favor, complete o seu perfil com suas informações, para que
                          sua experiência seja ainda mais personalizada.
                          <br>
                          <el-button
                             type="default"
                             size="mini"
                             class="mt-3 mb-2 font-strong"
                             @click="$router.push({name: 'profile'})"
                          >
                             Completar perfil
                          </el-button>

                       </template>
                       <br>
                    </el-alert>

                    <el-alert
                       v-if="!userDidNotCheckThePhone && userIsReady"
                       title="Verifique o número do seu telefone!"
                       type="error"
                       effect="dark"
                       :closable="false"
                    >
                       <template slot><p class="text-white pb-0 mb-0 mt-2 h6">Atenção: para você usar os serviços da nossa plataforma, você precisa verificar o número do seu telefone.</p>
                          <br>
                          <el-button
                             type="white"
                             size="mini"
                             class="mb-2 font-strong"
                             @click="$router.push({name: 'profile'})"
                          >
                             Ok, verificar número de telefone
                          </el-button>

                       </template>
                       <br>
                    </el-alert>
                 </div>
              </b-col>
              <b-col cols="12" lg="6" class="mb-4 mb-lg-0">
                 <AdvertiseYourBike
                    class="mb-3"
                    title="Quer buscar uma bike?"
                    desc="Se você pretende pedalar, então pesquise e encontre agora mesmo a bike ideal para você. Clique no botão abaixo."
                    background="rgb(22 171 129)"
                    :onClick="() => this.$router.push({name: 'search', params: { options: 'new' }})"
                 />
                 <AdvertiseYourBike
                    :ready="userIsReady"
                    background="rgb(31, 68, 61)"
                    :title="!user.bikes.length ? 'Quer cadastrar sua bike?' : 'Veja seus pedidos'"
                    :desc="!user.bikes.length ? 'Se você pretende anunciar a sua bike para locação, basta completar o seu perfil. Se for o seu caso, clique no botão abaixo.' : 'Acesse a sua página pedidos no painel do Anfitrião e gerencie seus pedidos de reserva. Clique no botão abaixo.'"
                    :onClick="() => !user.bikes.length ?
                    this.$router.push({name: 'my-bikes',  params: { page: 'minhas-bicicletas' }}) :
                    this.$router.push({name: 'my-bikes',  params: { page: 'pedidos' }})
                     "
                 />
                 <b-row class="dashboard-shortcuts mt-3">

                    <b-col cols="12" md="6" class="mb-4 mb-md-0">
                       <router-link to="/painel/anunciante/minhas-bicicletas" class="rounded p-4 shadow d-block item">
                          <h6><i class="el-icon-s-custom d-block mb-3"></i> Painel do <br>Anfitrião</h6>
                       </router-link>
                    </b-col>

                    <b-col cols="12" md="6" class="mb-4 mb-md-0">
                       <router-link to="/painel/ciclista/minhas-reservas" class="rounded p-4 shadow d-block item">
                          <h6><i class="el-icon-user d-block mb-3"></i> Painel do <br>Ciclista</h6>
                       </router-link>
                    </b-col>

<!-- <b-col cols="12" md="4" class="mb-4 mb-md-0">
                       <router-link to="/painel/minha-conta/perfil" class="rounded p-4 shadow d-block item">
                          <h4><i class="el-icon-set-up d-block mb-3"></i> Minha <br>Conta</h4>
                       </router-link>
                    </b-col>-->


                 </b-row>
              </b-col>
              <b-col cols="12" lg="6" style="margin-top: -16px">
                 <UserVerificationCard showCTA></UserVerificationCard>
              </b-col>
           </b-row>

<!--          <el-divider content-position="left">Acesso Rápido</el-divider>-->

        </b-col>
      </b-row>
    </b-container>

  </div>
</template>

<script>
import DashUserNav from "@/components/DashUserNav";
// eslint-disable-next-line no-unused-vars
import Permission from "@/helpers/Permission"
// eslint-disable-next-line no-unused-vars
import UserService from "@/services/user.service"
import {metaTags} from "@/helpers";
import user from '@/models/User';
import AdvertiseYourBike from "@/components/AdvertiseYourBike";
import UserVerificationCard from "@/components/UserVerificationCard";

export default {
  name: 'Dashboard',
   metaInfo: metaTags(`Dashboard`),
  components: {
    DashUserNav,
    AdvertiseYourBike,
     UserVerificationCard
  },
  data() {
    return {
      date: this.$moment().format('DD [de] MMMM [de] YYYY'),
      user: user,
      userIsReady: true,
      userHasBankAccount: false,
      userHasDigitalAccount: false,
      userDidNotCheckThePhone: true,
       loading: {
         user: false
       }
    }
  },
  beforeCreate() {

  },
  async mounted() {

     try {
        const user = await this.getUser();

        if (user) {
           if (this.user._id) {
              const checkUser = new Permission(this.user)
              this.userIsReady = checkUser.userIsReady()

              this.userHasBankAccount = checkUser.userHasBankAccount()
              this.userHasDigitalAccount = checkUser.userHasDigitalAccount()
              this.userDidNotCheckThePhone  = checkUser.thePhoneIsVerified()
           }
        }
     } catch (e) {
        this.$message({
           message: "Sistema indisponível. Tente novamente mas tarde.",
           type: 'error'
        });
     }



  },
  methods: {

     async getUser() {
       try {
          this.loading.user = true
          await this.$store.dispatch('user/get', await UserService.getUserData())

          if (this.userData.data._id) {
             this.user = this.userData.data
             this.loading.user = false
             return true
          }

       } catch (e) {
          this.$message({
             message: "Sistema indisponível. Tente novamente mas tarde.",
             type: 'error'
          });
       }
     },

    clear() {
      this.$store.dispatch('user/clear')
    }

  },
  computed: {
     currentUser() {
        return this.$store.state.auth.user;
     },
     userData() {
        return this.$store.state.user
     },

  },
  watch: {

  }
}
</script>

<style scoped>

</style>
